/**
 * StringInput Component
 *
 * Simple text input for string field filters.
 * Used for operators: CONTAINS, NOT_CONTAINS, EQUAL, NOT_EQUAL, STARTS_WITH, ENDS_WITH
 */

import { Input } from 'antd'

interface StringInputProps {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
}

export function StringInput({ value, onChange, placeholder }: StringInputProps) {
  return (
    <Input
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || 'Enter text'}
      allowClear
      style={{ width: '100%' }}
    />
  )
}
